export type LoginInfoStatus = "available" | "password_set" | "expired" | "unavailable" | "disabled"
export type LoginInfo = { user_public_id: string; nickname: string; username: string; password_setup_required: boolean; login_info_status: LoginInfoStatus; temporary_password?: string; expires_at?: string }
export type LoginDelivery = { organization_name: string; items: LoginInfo[] }
import { httpClient } from "./httpClient"
import type { FilePreviewGrantDTO } from "./adminTypes"
export type Organization = {
  public_id: string
  name: string
  code: string
  status: "active" | "suspended" | "terminated"
  seat_limit: number
  allocated_seats: number
  version: number
}
export type OrganizationApplication = {
  public_id: string
  name: string
  requested_seats: number
  note: string
  material_asset_ids: string[]
  status: "pending_review" | "approved" | "rejected"
  review_note: string
  version: number
  applicant_name?: string
  approved_seats: number
}
export type OrganizationMember = {
  password_setup_required: boolean
  login_info_status: LoginInfoStatus
  login_info_expires_at?: string
  user_public_id: string
  username: string
  nickname: string
  status: "active" | "disabled"
  remark: string
  sequence_number: number
}
export type OrganizationBatch = {
 available_count: number
 renewable_count: number
 password_set_count: number
  public_id: string
  status: "pending" | "processing" | "succeeded"
  requested_count: number
  generated_count: number
  credential_expires_at: string
}
export type OrganizationCourse = {
  cover_url?: string
  public_id: string
  course_id: string
  title: string
  status: string
  price_cent: number
  enrolled_members: number
}
export type Page<T> = {
  items: T[]
  total: number
  page: number
  page_size: number
}
export type ApplicationInput = {
  name: string
  requested_seats: number
  note: string
  material_asset_ids: string[]
}

export const organizationAdminGateway = {
  application: (id: string) =>
    httpClient.get<OrganizationApplication>(
      "/admin/organization-applications/" + encodeURIComponent(id),
    ),
  review: (
    id: string,
    input: {
      decision: "approve" | "reject"
      approved_seats: number
      note?: string
      version: number
    },
  ) =>
    httpClient.post<OrganizationApplication>(
      "/admin/organization-applications/" + encodeURIComponent(id) + "/review",
      input,
    ),
  material: (id: string, file: string) =>
    httpClient.post<FilePreviewGrantDTO>(
      "/admin/organization-applications/" +
        encodeURIComponent(id) +
        "/materials/" +
        encodeURIComponent(file) +
        "/access",
    ),
  get: (id: string) =>
    httpClient.get<Organization>(
      "/admin/organizations/" + encodeURIComponent(id),
    ),
  update: (
    id: string,
    input: { status: string; seat_limit: number; version: number },
  ) =>
    httpClient.put<Organization>(
      "/admin/organizations/" + encodeURIComponent(id),
      input,
    ),
  members: (id: string, page: number) =>
    httpClient.get<Page<OrganizationMember>>(
      "/admin/organizations/" +
        encodeURIComponent(id) +
        "/members?page=" +
        page +
        "&page_size=20",
    ),
  loginInfo: (id: string, user: string) => httpClient.post<LoginDelivery>("/admin/organizations/"+encodeURIComponent(id)+"/members/"+encodeURIComponent(user)+"/login-info"),
  renewLoginInfo: (id: string, user: string) => httpClient.post<LoginDelivery>("/admin/organizations/"+encodeURIComponent(id)+"/members/"+encodeURIComponent(user)+"/login-info/renew"),
  member: (id: string, member: OrganizationMember, status: string) =>
    httpClient.put(
      "/admin/organizations/" +
        encodeURIComponent(id) +
        "/members/" +
        encodeURIComponent(member.user_public_id),
      { status, remark: member.remark },
    ),
  reset: (id: string, user: string) =>
    httpClient.post<LoginDelivery>(
      "/admin/organizations/" +
        encodeURIComponent(id) +
        "/members/" +
        encodeURIComponent(user) +
        "/password-reset",
    ),
  courses: (id: string, page: number) =>
    httpClient.get<Page<OrganizationCourse>>(
      "/admin/organizations/" +
        encodeURIComponent(id) +
        "/courses?page=" +
        page +
        "&page_size=20",
    ),
}
